import { Button } from "primereact/button"
import { Card } from "primereact/card"

const ControlPanel = ({ t, setExerciseDialogVisible, tabIndex, setTabIndex, selectedPatient,patientDetailOp }: any) => {
    return (
        <>
            <Card style={{ borderRadius: "12px", position: "relative" }} className="controlPanel">
                <div className="flex justify-content-between align-items-center">
                    <div className="flex justify-content-start align-items-center gap-2">
                        <img onClick={(e) => patientDetailOp.current?.toggle(e)} src={`${selectedPatient.gender === "Male" ? "/Man.png" : "/Female.png"}`}
                            style={{ borderRadius: "100px", width: "3rem", height: "3rem",cursor: "pointer" }}
                        />
                        <p className="m-0 text-lg font-bold mr-4" style={{ color: "#2D3967" }}>{selectedPatient.firstName} {selectedPatient.lastName}</p>
                        <Button

                            onClick={() => setTabIndex(0)}
                            style={{
                                backgroundColor: tabIndex === 0 ? "#6383F4" : "#FFFFFF",
                                color: tabIndex === 0 ? "#FFFFFF" : "#2D3967",
                                borderRadius: "10px",
                                border: "none",
                            }} >
                            <span className="flex justify-content-center align-items-center gap-2 font-bold" style={{ width: "100%" }}>
                                {tabIndex === 0 ? <img src="/prescription.svg" /> : <img src="/plansAndProgressIcon.svg" />}
                                {t("plansAndProgress")}
                            </span>
                        </Button>
                        <Button

                            onClick={() => setTabIndex(1)}
                            style={{
                                backgroundColor: tabIndex === 1 ? "#6383F4" : "#FFFFFF",
                                color: tabIndex === 1 ? "#FFFFFF" : "#2D3967",
                                borderRadius: "10px",
                                border: "none",
                            }} >
                            <span className="flex justify-content-center align-items-center gap-2 font-bold" style={{ width: "100%" }}>
                                {tabIndex === 1 ? <img src="/painInformationWhiteIcon.svg" /> : <img src="/painInformationIcon.svg" />}
                                {t("patientHistory")}
                            </span>
                        </Button>
                    </div>
                    <div className="flex flex-wrap gap-2">

                        {tabIndex === 0 && <>
                            <Button
                                onClick={() => { setExerciseDialogVisible(true) }}
                                style={{
                                    backgroundColor: "#E3506B",
                                    color: "white",
                                    border: "#E3506B",
                                    height: "3rem",
                                    borderRadius: "10px",
                                    width: "12rem",
                                    fontWeight: "bold"
                                }}
                            >
                                <span className="flex justify-content-center align-items-center gap-2 font-bold" style={{ width: "100%" }}>
                                    <img src="/addPatientIcon.svg" />
                                    {t("addPlan")}
                                </span>
                            </Button>
                        </>}
                    </div>
                </div>
            </Card>

        </>
    )
}

export default ControlPanel